/**
* @constant {object} standardLabels contains constants that can help ensure the correct label names are being used. Includes: neutral, brand, interactive, accent, tertiary,
danger, warning, success
*/
export const standardLabels = {
  neutral: 'neutral',
  brand: 'brand',
  interactive: 'interactive',
  accent: 'accent',
  tertiary: 'tertiary',
  danger: 'danger',
  warning: 'warning',
  success: 'success',
  accessoryOne: 'accessoryOne',
  accessoryTwo: 'accessoryTwo',
  accessoryThree: 'accessoryThree',
  accessoryFour: 'accessoryFour',
  accessoryFive: 'accessoryFive'
};

/**
 * @constant {object} standardDefinitions property contains arrays representing sets of parameters for all Carina standard stacks. For example, to build the standard Carina interactive stack: createColorStack(...standardDefinitions.interactive)
 */
export const standardDefinitions = {
  [standardLabels.neutral]: [
    '#9A9FA6',
    standardLabels.neutral,
    false,
    {
      default: {
        10: 'rgb(247,248,249)',
        15: 'rgb(217,220,222)',
        30: 'rgb(154, 159, 166)',
        45: 'rgb(105,113,122)',
        70: 'rgb(74,80,89)',
        100: 'rgb(52,56,63)',
        150: 'rgb(26,32,38)'
      }
    }
  ],
  [standardLabels.brand]: [
    '#006ae1',
    standardLabels.brand,
    false,
    {
      default: {
        15: '#CFE4FC',
        30: '#4494EF',
        45: '#006DE9',
        70: '#004CD6',
        100: '#0025BD',
        150: '#010D8E'
      },
      dark: {
        10: '#000646',
        13: '#000F5E',
        15: '#00156D',
        20: '#0A359F',
        30: '#1357D4',
        45: '#308DF6',
        70: '#81B9F9',
        100: '#CFE4FC',
        150: '#F2F8FE'
      }
    }
  ],
  [standardLabels.interactive]: ['#006ae1', standardLabels.interactive, true],
  [standardLabels.accent]: [
    '#00ca9d',
    standardLabels.accent,
    false,
    { default: { 30: '#00ca9d' }, dark: { 30: '#007F63' } }
  ],
  [standardLabels.tertiary]: ['#8457D9', standardLabels.tertiary, true],
  [standardLabels.danger]: ['#E02D00', standardLabels.danger],
  [standardLabels.warning]: ['#FFCC00', standardLabels.warning, true],
  [standardLabels.success]: ['#008A00', standardLabels.success],
  [standardLabels.accessoryOne]: [
    '#B473E9',
    standardLabels.accessoryOne,
    false,
    {
      default: {
        10: '#FDD1F6',
        15: '#F1AEF3',
        20: '#D490F1',
        30: '#B473E9',
        45: '#8457D9',
        70: '#4D31BA',
        100: '#1C1386'
      },
      dark: {
        10: '#1C1386',
        15: '#4D31BA',
        20: '#8457D9',
        30: '#B473E9',
        45: '#D490F1',
        70: '#F1AEF3',
        100: '#FDD1F6'
      }
    }
  ],
  [standardLabels.accessoryTwo]: [
    '#0781DA',
    standardLabels.accessoryTwo,
    false,
    {
      default: {
        10: '#A6F6E0',
        15: '#64E4E8',
        20: '#2FC7F0',
        30: '#17A6F8',
        45: '#0781DA',
        70: '#1C4EB4',
        100: '#192887'
      },
      dark: {
        10: '#192887',
        15: '#1C4EB4',
        20: '#0781DA',
        30: '#17A6F8',
        45: '#2FC7F0',
        70: '#64E4E8',
        100: '#A6F6E0'
      }
    }
  ],
  [standardLabels.accessoryThree]: [
    '#05BAA5',
    standardLabels.accessoryThree,
    false,
    {
      default: {
        10: '#B7F4AC',
        15: '#77E9A1',
        20: '#07D7A8',
        30: '#05BAA5',
        45: '#059A9A',
        70: '#047885',
        100: '#02516C'
      },
      dark: {
        10: '#02516C',
        15: '#047885',
        20: '#059A9A',
        30: '#05BAA5',
        45: '#07D7A8',
        70: '#77E9A1',
        100: '#B7F4AC'
      }
    }
  ],
  [standardLabels.accessoryFour]: [
    '#DF4E0F',
    standardLabels.accessoryFour,
    false,
    {
      default: {
        10: '#FFE982',
        15: '#FFCC66',
        20: '#FFAB00',
        30: '#FF7830',
        45: '#DF4E0F',
        70: '#B22205',
        100: '#790C03'
      },
      dark: {
        10: '#790C03',
        15: '#B22205',
        20: '#DF4E0F',
        30: '#FF7830',
        45: '#FFAB00',
        70: '#FFCC66',
        100: '#FFE982'
      }
    }
  ],
  [standardLabels.accessoryFive]: [
    '#C2386C',
    standardLabels.accessoryFive,
    false,
    {
      default: {
        10: '#FFCCA1',
        15: '#FFB2A3',
        20: '#FF8888',
        30: '#F05887',
        45: '#C2386C',
        70: '#891150',
        100: '#5D074A'
      },
      dark: {
        10: '#5D074A',
        15: '#891150',
        20: '#C2386C',
        30: '#F05887',
        45: '#FF8888',
        70: '#FFB2A3',
        100: '#FFCCA1'
      }
    }
  ]
};

export default {
  standardLabels,
  standardDefinitions
};
